<!--
================================================
Vue affichant la view post inscription contenant le formumlaire dataSignup (taille orga, etc.)
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <outdoor-layout-comp>
    <div slot="AppContent">
      <signup-data-comp></signup-data-comp>
    </div>

  </outdoor-layout-comp>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
// @ is an alias to /src
import OutdoorLayoutComp from '@/components/OutdoorLayoutComp.vue'
import SignupComp from '@/components/SignupComp.vue'
import VueMetaMixin from "../mixins/VueMetaMixin.js";
import SignupDataComp from "@/components/SignupDataComp";

export default {
  name: 'SignupDataView',
  components: {
    SignupDataComp,
    OutdoorLayoutComp,
    SignupComp
  },
  mixins: [VueMetaMixin],
  metaInfo(){
    return this.setMeta(this.$t("metaTitleSignupDataView"),this.$t("metaDescSignupDataView"))
  },
  methods: {
  },
  created: function () {
  }
  //==========================================================
}
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
/*ATTENTION : css non "scoped" s'applique à tout le html*/

html {
}

</style>

<style scoped lang="scss">


</style>
